import { lazy } from "react";

export const LazyCategoryLandingPage = lazy(() =>
  import(
    /* webpackChunkName: "brands-category" */ "./CategoryLandingPage"
  ).then((m) => ({ default: m.CategoryLandingPage }))
);
